import { Link } from "react-router-dom";
import React from "react";
import "../../../../sass/viewer.scss";
import Context from "../../../Context";
import EssenceActionsDropdown from "../../Essence/EssenceActionsDropdown";
import EssenceStateLabel from "../../Essence/EssenceStateLabel";
import Blocker from "../../Misc/Blocker";
import DefaultNotFound from "../../Misc/DefaultNotFound";
import ReactResizeDetector from "react-resize-detector";
import WorkdocItemInfo from "../Workdoc/WorkdocItemInfo";
import ManualVersions from "./ManualVersions";
import Fav from "../../Misc/Fav";
import FamManual from "../../Misc/Fam/FamManual";
import EssenceAreaChange from "../../Essence/EssenceAreaChange";
import comparsion from "./comparsion";
import ManualFam from "./ManualFam";
import CommentsButton from "../../Misc/Comments/CommentsButton";

export default class ManualView extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      openItemInfo: false,
      roles: {},
      sourceRole: {},
      canEditRoles: false,
      openRolesModal: false,

      comparsionMode: false,
      comparsionWith: false,
      comparsionResult: "",
      docCompare: {},

      pending: false,
      notFound: false,
      doc: {},
      scale: 0.5,
      containerRef: React.createRef(),
      documentRef: React.createRef(),

      versions: [],
      docVersion: {},

      famManualKey: "",
    };
  }
  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.document !== this.props.document) {
      this.load();
    }
    if (prevProps.version !== this.props.version) {
      if (this.state.comparsionMode) {
        this.comparsionStart();
      } else {
        this.load();
      }
    }
  }
  load = async () => {
    if (this.props.document) {
      this.setState({ pending: true });

      let doc = await this.context.api.q("/manual/get", {
        id: this.props.document,
        fields: [
          "id",
          "label",
          "type",
          "statetypecode",
          "statecode",
          "statelabel",
          "structure",
          "classcode",
          "contentid",
          "rendered",
          "version",
          "created",
        ],
      });
      this.setState({ doc });

      if (doc) {
        this.setState({
          canEditRoles: doc.statetypecode === "created" ? true : false,
          notFound: false,
        });
      }

      let roles = await this.context.api.qo(`/participant/list`, {
        search: [
          {
            field: "document",
            compare: "EQL",
            value: this.props.document,
          },
        ],
      });
      this.setState({ roles });

      let versions = await this.context.api.qa("/manual/content/list", {
        filter: { manual: this.props.document },
        fields: ["id", "version", "validfromdate"],
      });
      this.setState({ versions });

      if (this.props.version && doc) {
        let docVersion = await this.context.api.q("/manual/content/get", {
          id: this.props.version,
        });
        this.setState({ docVersion });
      }

      if (this.state.comparsionMode && this.state.comparsionWith && doc) {
        let docCompare = await this.context.api.q("/manual/content/get", {
          id: this.state.comparsionWith,
        });
        this.setState({ docCompare });
      }

      if (
        !doc.id ||
        (String(doc.structure) !== this.props.structure &&
          this.props.structure !== "all")
      ) {
        this.setState({ notFound: true });
      }
      this.setState({ pending: false });
      this.adjustScale();
    } else {
      this.setState({ notFound: true });
    }
  };
  onMethodFinish = () => {
    this.load();
  };

  toggleRolesModal = (sourceRole) => {
    this.setState((state) => {
      return {
        sourceRole: sourceRole || {},
        openRolesModal: !state.openRolesModal,
        openItemInfo: !state.openRolesModal ? true : state.openItemInfo,
      };
    });
  };

  toggleOpenInfo = () => {
    this.setState((state) => {
      return { openItemInfo: !state.openItemInfo };
    });
  };

  comparsionToggleMode = () => {
    this.setState(
      (state) => {
        return {
          comparsionMode: !state.comparsionMode,
          //comparsionWith: this.props.version,
          comparsionResult: "",
        };
      },
      () => this.comparsionStart()
    );
  };

  comparsionOnVersionChange = (version) => {
    this.setState({ comparsionWith: version.id }, () => this.comparsionStart());
  };

  comparsionStart = async () => {
    if (this.state.comparsionMode) {
      await this.load();
      const { doc = {}, docCompare = {}, docVersion = {} } = this.state;

      let currentDoc = docVersion.version ? docVersion : doc;
      let compareDoc = docCompare.version ? docCompare : doc;

      this.setState({
        comparsionResult: comparsion.run(currentDoc, compareDoc),
      });
    }
  };

  onResize = () => {
    if (this.state.doc.id && !this.state.pending) {
      this.adjustScale();
    }
  };

  getDocumentContent = () => {
    const { doc = {}, docVersion = {} } = this.state;
    if (this.state.comparsionMode) {
      return this.state.comparsionResult || "";
    }
    if (docVersion.rendered) {
      return docVersion.rendered;
    }
    return doc.rendered;
  };

  adjustScale = () => {
    let container = this.state.containerRef.current;
    let document = this.state.documentRef.current;

    if (container) {
      const containerWidth = container.offsetWidth;

      if (containerWidth) {
        let scale = containerWidth / 991;
        if (scale > 1) scale = 1;

        this.setState({ scale });
        if (document) {
          const documentHeight = document.offsetHeight;
          if (documentHeight) {
            let newHeight = Math.ceil(documentHeight * scale);
            container.style.height = `${newHeight}px`;
          }
        }
      }
    }
  };

  onAfterFamiliarize = () => {
    this.setState({ famManualKey: this.context.key() });
  };

  render() {
    const doc = this.state.doc || {};
    const docVersion = this.state.docVersion || {};
    let famItemId = docVersion.id ? docVersion.id : doc.contentid;

    return (
      <>
        <ReactResizeDetector
          handleWidth
          handleHeight={false}
          onResize={this.onResize}
        >
          {!this.state.notFound && (
            <div className="card card-custom p-4 mb-4">
              <div className="d-flex justify-content-between align-items-center">
                <div className="pl-2">
                  {famItemId && (
                    <ManualFam
                      onAfterFamiliarize={this.onAfterFamiliarize}
                      itemId={famItemId}
                    />
                  )}
                </div>
                <div className="d-flex justify-content-end align-items-center  ">
                  <CommentsButton objectId={doc.id}>
                    <i className="fa fa-comment-o"></i>
                  </CommentsButton>

                  <Fav
                    className="btn btn-icon btn-white "
                    itemId={doc.id}
                    item={doc}
                  />
                  {doc.statetypecode === "created" ? (
                    <Link
                      to={`/manual/${doc.structure}/${doc.id}/edit/`}
                      title="Редактировать"
                      className="btn  btn-white   btn-icon"
                    >
                      <i className="fa fa-pencil"></i>
                    </Link>
                  ) : null}

                  <Link
                    to={`/manual/${doc.structure}/${doc.classcode}/add/?copy=${doc.id}`}
                    title="Открыть копию"
                    className="btn btn-white btn-icon"
                  >
                    <span className="flaticon2-copy"></span>
                  </Link>

                  {this.state.canEditRoles ? (
                    <button
                      title="Участники"
                      onClick={() => this.toggleRolesModal()}
                      className="btn btn-white btn-icon"
                    >
                      <i className="fa fa-address-book-o"></i>
                    </button>
                  ) : null}

                  <EssenceAreaChange
                    item={doc}
                    onFinish={this.onMethodFinish}
                    button={(onClick) => (
                      <div
                        title="Сменить подразделение"
                        className="btn btn-white btn-icon"
                        onClick={onClick}
                      >
                        <i className="fa fa-sitemap"></i>
                      </div>
                    )}
                  />

                  <button
                    title="Режим сравнения"
                    onClick={() => this.comparsionToggleMode()}
                    className={`btn btn-icon ${
                      this.state.comparsionMode ? "btn-warning" : "btn-white"
                    }`}
                  >
                    <i className="fa fa-balance-scale"></i>
                  </button>

                  <FamManual docId={doc.id} key={this.state.famManualKey} />

                  <div className="ml-1 pl-2 border-left d-flex justify-content-end align-items-center">
                    <EssenceStateLabel
                      id={doc.id}
                      stateCode={doc.statetypecode}
                      stateLabel={doc.statelabel}
                      essence="manual"
                    />
                    <EssenceActionsDropdown
                      essence={"manual"}
                      key={doc.id}
                      id={doc.id}
                      label={doc.label}
                      onFinish={this.onMethodFinish}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="card card-custom card-stretch1">
            <Blocker on={this.state.pending}>
              {!this.state.notFound ? (
                <div className="card-header document-view-title document-view-container px-5 pb-3 pt-5 w-100">
                  <div className="d-flex  justify-content-between align-items-start w-100">
                    <div className="pr-7">
                      <div
                        className="font-weight-bold h5 cursor-pointer"
                        onClick={this.toggleOpenInfo}
                      >
                        {doc.label}
                        <i
                          className={`fa ml-2 ${
                            this.state.openItemInfo
                              ? "fa-angle-up"
                              : "fa-angle-down"
                          }`}
                        ></i>
                      </div>
                      <table>
                        <tbody>
                          <tr>
                            <td className="pr-2">Версия:</td>
                            <td>
                              {this.state.versions.length > 0 && (
                                <ManualVersions
                                  versions={this.state.versions}
                                  item={this.state.doc}
                                  currentVersion={this.props.version}
                                  onVersionChange={this.props.onVersionChange}
                                />
                              )}
                            </td>
                          </tr>
                          {this.state.comparsionMode && (
                            <tr>
                              <td className="pr-2">Сравнение с:</td>
                              <td>
                                {this.state.versions.length > 0 && (
                                  <ManualVersions
                                    versions={this.state.versions}
                                    item={this.state.doc}
                                    currentVersion={this.state.comparsionWith}
                                    onVersionChange={
                                      this.comparsionOnVersionChange
                                    }
                                  />
                                )}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {this.state.openItemInfo && (
                    <div className="pt-3 pb-2 mt-3 border-top">
                      <WorkdocItemInfo
                        onRoleDelete={this.onRoleDelete}
                        item={doc}
                        openRolesModal={this.state.openRolesModal}
                        toggleRolesModal={this.toggleRolesModal}
                        sourceRole={this.state.sourceRole}
                      />
                    </div>
                  )}
                </div>
              ) : null}
              <div
                className="card-body p-0 document-view-container"
                ref={this.state.containerRef}
              >
                {this.state.notFound ? (
                  <DefaultNotFound message="Запрашиваемый документ не найден или недоступен" />
                ) : (
                  <div
                    ref={this.state.documentRef}
                    style={{ transform: `scale(${this.state.scale})` }}
                    className="documentViewer fit"
                    dangerouslySetInnerHTML={{
                      __html: this.getDocumentContent(),
                    }}
                  ></div>
                )}
              </div>
            </Blocker>
          </div>
        </ReactResizeDetector>
      </>
    );
  }
}
